import React from 'react';
import { toast } from 'sonner';
import FileUpload from '../../../components/FileUpload/FileUpload';
import CustomSelect from '../../../components/forms/CustomSelect';
import HorizontalFormBlockWrapper from '../../../components/forms/HorizontalFormBlockWrapper';
import { usePrivilege } from '../../../components/priviledge/PriviledgeProvider';
import PageHeader from '../../../layout/shared/page-header';
import { menuRoutes } from '../../../router/menu';
import { PlatformAdvanceService } from '../../../services/platform-advance/platformAdvanceService';
import FormFooter from '../../_layout/_footers/form-footer';
import useHandleErrors from '../../../hooks/useHandleErrors';
import { useSettingsProvider } from '../provider/SettingsProvider';
import useRoles from '../../../hooks/api-calls/useRoles';
import useOrderStatuses from '../../../hooks/api-calls/orders/useOrderStatuses';

const pageHeader = {
    title: 'Ajustes en Pedidos',
    breadcrumb: [
        { name: 'Inicio', href: menuRoutes.dashboard.path },
        { name: 'Configuración' },
        { name: 'Pedidos', href: menuRoutes.settings.path + menuRoutes.settings.orders },
    ]
}

const OrdersSettingsPage: React.FC = () => {
    const { userCan } = usePrivilege();
    const { handleErrors } = useHandleErrors();
    const { formik, hasCompanyConfigChanges, isLoading, companyConfig, updateCompanyConfig, setShowModal, discardCompanyConfigChanges } = useSettingsProvider();
    const { fetchRoles, getRolesList } = useRoles();
    const { fetchOrderStatusesList, getOrderStatusesList } = useOrderStatuses();
    const [platformAdvanceFiles, setPlatformAdvanceFiles] = React.useState<File[]>([]);

    React.useEffect(() => {
        fetchRoles();
        fetchOrderStatusesList();
    }, []);

    const roleOptions = getRolesList();
    const orderStatusOptions = getOrderStatusesList();
    const facilitatorRoleIds = companyConfig?.facilitatorRoleIds ?? [];
    const facilitatorManagerRoleIds = companyConfig?.facilitatorManagerRoleIds ?? [];
    const facilitatorOrderStatusIds = companyConfig?.facilitatorOrderStatusIds ?? [];
    const selectedFacilitatorRoles = roleOptions.filter((option: any) => facilitatorRoleIds.includes(option.value));
    const selectedFacilitatorManagerRoles = roleOptions.filter((option: any) => facilitatorManagerRoleIds.includes(option.value));
    const selectedFacilitatorOrderStatuses = orderStatusOptions.filter((option: any) => facilitatorOrderStatusIds.includes(option.value));

    const updateArrayConfiguration = (
        field: 'facilitatorRoleIds' | 'facilitatorManagerRoleIds' | 'facilitatorOrderStatusIds',
        selected: any
    ) => {
        const selectedIds = Array.isArray(selected) ? selected.map((option: any) => option.value) : [];
        updateCompanyConfig(field, selectedIds);
        formik.setFieldValue(field, selectedIds);
    };


    return (
        <div className='h-full overflow-auto scrollbar '>
            <PageHeader
                title={pageHeader.title}
                breadcrumb={pageHeader.breadcrumb}
                className='border-b-4 border-dotted border-grey-500 top-0'
            />

            <HorizontalFormBlockWrapper
                title="Configuración de Dinamizadores y Pedidos"
                description="Define los roles de dinamización y los estados de pedido que serán visibles en el flujo del módulo."
                childrenWrapperClassName="@md:col-span-10 md:grid-cols-2"
            >
                <CustomSelect
                    id='facilitatorRoleIds'
                    label='Roles de dinamizador'
                    placeholder='Selecciona uno o varios roles'
                    options={roleOptions}
                    isMulti
                    isClearable
                    value={selectedFacilitatorRoles}
                    onChange={(selected) => updateArrayConfiguration('facilitatorRoleIds', selected)}
                    error={formik.errors.facilitatorRoleIds as string}
                    containerClassName='pb-4'
                />

                <CustomSelect
                    id='facilitatorManagerRoleIds'
                    label='Roles de manager dinamizador'
                    placeholder='Selecciona uno o varios roles'
                    options={roleOptions}
                    isMulti
                    isClearable
                    value={selectedFacilitatorManagerRoles}
                    onChange={(selected) => updateArrayConfiguration('facilitatorManagerRoleIds', selected)}
                    error={formik.errors.facilitatorManagerRoleIds as string}
                    containerClassName='pb-4'
                />

                <div className='md:col-span-2'>
                    <CustomSelect
                        id='facilitatorOrderStatusIds'
                        label='Estados visibles para dinamizadores'
                        placeholder='Selecciona uno o varios estados'
                        options={orderStatusOptions}
                        isMulti
                        isClearable
                        value={selectedFacilitatorOrderStatuses}
                        onChange={(selected) => updateArrayConfiguration('facilitatorOrderStatusIds', selected)}
                        error={formik.errors.facilitatorOrderStatusIds as string}
                        containerClassName='pb-4'
                    />
                </div>
            </HorizontalFormBlockWrapper>

            {hasCompanyConfigChanges && (
                <FormFooter
                    customClassName={"w-full"}
                    submitBtnText={"Aplicar Cambios"}
                    cancelBtnText={"Descartar Cambios"}
                    handleCancelBtn={() => discardCompanyConfigChanges()}
                    handleSubmitBtn={() => setShowModal(true)}
                    isLoading={isLoading}
                    isDisabled={Object.keys(formik.errors).length > 0}
                />
            )}
        </div>
    );
};

export default OrdersSettingsPage;
